export default __webpack_public_path__ + "static/media/file-text.23ec322c.svg";